var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDfinLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 52,
    viewBox: "0 0 185 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.25 51.9328H129.899V0.0446777H115.25V51.9328Z",
    fill: "#2D235A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.824 0.0447066H69.3332C66.3809 0.0447066 63.9878 2.43782 63.9878 5.39008V50.7922C63.9878 51.4185 64.5022 51.9105 65.1061 51.9105H77.4966C78.1229 51.9105 78.6149 51.4185 78.6149 50.7922V37.5742C78.6149 37.4176 78.7491 37.2834 78.9057 37.2834H107.847V24.2443H78.9057C78.7491 24.2443 78.6149 24.1101 78.6149 23.9535V14.9178C78.6149 14.7613 78.7491 14.6271 78.9057 14.6271H107.847V0",
    fill: "#2D235A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.465 0.0446777H171.074C170.448 0.0446777 169.956 0.559086 169.956 1.16296V26.8387C169.956 27.1294 169.598 27.2189 169.442 26.9952L153.652 2.572C152.578 0.984044 150.811 0.0446777 148.888 0.0446777H137.302V51.9552H150.811C151.437 51.9552 151.929 51.4632 151.929 50.837V26.8163C151.929 26.5479 152.287 26.4361 152.444 26.6598L168.212 49.5397C169.285 51.0606 171.03 51.9776 172.908 51.9776H183.442C184.069 51.9776 184.561 51.4855 184.561 50.8593V1.2077C184.561 0.581461 184.046 0.0894185 183.442 0.0894185",
    fill: "#2D235A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2064 0.0446777H5.34534C2.39308 0.0446777 0 2.43779 0 5.39005V26.0111C0 30.0369 3.28772 33.3023 7.31352 33.3023C11.3393 33.3023 14.6271 30.0369 14.6271 26.0111V15.8124C14.6271 15.1862 15.1415 14.6941 15.7454 14.6941H32.2959C38.6477 14.6941 43.9484 19.883 43.8366 26.2348C43.7247 32.3853 38.6925 37.3281 32.5196 37.3281H1.11828C0.492043 37.3281 0 37.8425 0 38.4688V50.8817C0 51.5079 0.51443 52 1.14067 52L32.5419 51.9552C46.9454 51.9552 58.5978 40.2357 58.486 25.8098C58.3742 11.4959 46.5204 0.0670652 32.2064 0.0670652",
    fill: "#8700FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDfinLogo);
export default __webpack_public_path__ + "static/media/dfin-logo.39651392d13aba6b088c2e58bb339e7c.svg";
export { ForwardRef as ReactComponent };